import { render, staticRenderFns } from "./CallForPapers.vue?vue&type=template&id=08ce6962&"
import script from "./CallForPapers.vue?vue&type=script&lang=js&"
export * from "./CallForPapers.vue?vue&type=script&lang=js&"
import style0 from "./CallForPapers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CallForPapers.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=.%2Fmy.css"
if (typeof block0 === 'function') block0(component)

export default component.exports